import { OrderObject } from './order-object.model';

export class OrderTable {

  constructor(public orderObjectList: Array<OrderObject>, public page: string, public total: string) {
  }


}